import { mapData } from "@/utilities/DataMapping";
import { PagePartComponent } from "../Enums";
import { IPagePartOptions } from "./IPagePartOptions";

export class NoteOptions implements IPagePartOptions {

    constructor(data?: IPagePartOptions) {
        if (data) this.update(data);
        if(!this.clientColourField) this.clientColourField = "noteColour1";
        if(!this.icon) this.icon = "mdi-information";
    }

    update(data: IPagePartOptions): NoteOptions {
        mapData(data, { root: () => this });
        return this;
    }

    get component(): PagePartComponent {
        return PagePartComponent.Note;
    }
    set component(value: PagePartComponent) {
        if(value != this.component) console.warn(`IPagePartOptions - trying to set component ${this.component} -> ${value}`)
    }

    // ADDING PROPERTIES - you also need to update the toJSON method!
    html: string = "";
    clientColourField: string = "";
    icon: string = "mdi-information";

    get isRedLineQuestion(): boolean { return false; }
    set isRedLineQuestion(value: boolean) {
        if(value) console.warn("IPagePartOptions - unsupported - trying to set isRedLineQuestion to true")
    }

    // getter / setter properties are not serialised by JSON.stringify unless we do this:
    toJSON(): any {
        return {
            component: this.component,
            html: this.html,
            clientColourField: this.clientColourField,
            icon: this.icon,
            isRedLineQuestion: this.isRedLineQuestion
        };
    }
}